const Species = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="91"
      height="90"
      viewBox="0 0 91 90"
      fill="none"
      {...props}
    >
      <ellipse
        cx="32.8125"
        cy="24.2768"
        rx="26.3125"
        ry="11.2768"
        stroke="#333333"
        stroke-width="4"
      />
      <path
        d="M59.1251 35.5537C59.1251 41.7817 47.3446 46.8305 32.8125 46.8305C18.2805 46.8305 6.5 41.7817 6.5 35.5537"
        stroke="#C89050"
        stroke-width="4"
      />
      <path
        d="M6.5 46.8301C6.5 53.0581 18.2805 58.1069 32.8125 58.1069C37.4039 58.1069 41.7207 57.6029 45.478 56.7169"
        stroke="#C89050"
        stroke-width="4"
      />
      <path
        d="M6.5 58.1074C6.5 64.3354 18.2805 69.3842 32.8125 69.3842C37.5665 69.3842 42.026 68.8439 45.8749 67.8988"
        stroke="#333333"
        stroke-width="4"
      />
      <path
        d="M59.125 24.2764L59.2022 44.8407"
        stroke="#333333"
        stroke-width="4"
        stroke-linecap="round"
      />
      <path
        d="M6.5 24.2764L6.5 58.1068"
        stroke="#333333"
        stroke-width="4"
        stroke-linecap="round"
      />
      <ellipse
        cx="65.7894"
        cy="52.7833"
        rx="19.6126"
        ry="8.4054"
        stroke="#333333"
        stroke-width="4"
      />
      <path
        d="M85.4019 61.1885C85.4019 65.8306 76.6211 69.5939 65.7893 69.5939C54.9576 69.5939 46.1768 65.8306 46.1768 61.1885"
        stroke="#C89050"
        stroke-width="4"
      />
      <path
        d="M85.4019 69.5938C85.4019 74.2359 76.6211 77.9991 65.7893 77.9991C54.9576 77.9991 46.1768 74.2359 46.1768 69.5938"
        stroke="#333333"
        stroke-width="4"
      />
      <path
        d="M85.4033 52.7832L85.4033 69.9053"
        stroke="#333333"
        stroke-width="4"
        stroke-linecap="round"
      />
      <path
        d="M46.1768 52.7832L46.1768 69.9053"
        stroke="#333333"
        stroke-width="4"
        stroke-linecap="round"
      />
    </svg>
  )
}

export default Species
